(() => {
  class AspadzHomeBanner extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.retryTimer = null;
      this.normalAutoplayDelay = 5000;
      this.hasRestoredInitialDelay = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handleMotionPreferenceChange = this.handleMotionPreferenceChange.bind(this);
    }

    connectedCallback() {
      this.init();
      this.addMotionListener();
    }

    disconnectedCallback() {
      window.clearTimeout(this.retryTimer);
      this.removeMotionListener();

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    addMotionListener() {
      if (this.reducedMotion.addEventListener) {
        this.reducedMotion.addEventListener('change', this.handleMotionPreferenceChange);
      } else {
        this.reducedMotion.addListener(this.handleMotionPreferenceChange);
      }
    }

    removeMotionListener() {
      if (this.reducedMotion.removeEventListener) {
        this.reducedMotion.removeEventListener('change', this.handleMotionPreferenceChange);
      } else {
        this.reducedMotion.removeListener(this.handleMotionPreferenceChange);
      }
    }

    init() {
      if (this.swiper) return;

      if (typeof window.AspadzConceptCarousel === 'undefined') {
        this.retryTimer = window.setTimeout(() => this.init(), 120);
        return;
      }

      const slider = this.querySelector('[data-aspadz-home-banner-slider]');
      const slides = this.querySelectorAll('.aspadz-home-banner__slide');
      if (!slider || slides.length < 2) return;

      const delay = Number(this.dataset.autoplayDelay) || 5000;
      // Flickity snapshots its autoplay interval at construction time, so use
      // the configured delay from the first slide instead of Swiper's short
      // boot interval that was mutated after initialization.
      const initialAutoplayDelay = delay;
      const pagination = this.querySelector('[data-aspadz-home-banner-pagination]');
      const nextButton = this.querySelector('[data-aspadz-home-banner-next]');
      const prevButton = this.querySelector('[data-aspadz-home-banner-prev]');

      this.normalAutoplayDelay = delay;
      this.hasRestoredInitialDelay = false;
      this.style.setProperty('--aspadz-home-banner-delay', `${initialAutoplayDelay}ms`);

      this.swiper = new window.AspadzConceptCarousel(slider, {
        autoplay: {
          delay: initialAutoplayDelay,
          disableOnInteraction: false,
        },
        loop: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          clickable: true,
          el: pagination,
          renderBullet(index, className) {
            return `
              <button class="${className}" type="button" aria-label="Go to slide ${index + 1}">
                <span class="aspadz-home-banner__pagination-track">
                  <span class="aspadz-home-banner__pagination-progress"></span>
                </span>
              </button>
            `;
          },
        },
        slidesPerView: 1,
        speed: 650,
        watchOverflow: true,
        on: {
          slideChangeTransitionStart: () => this.restoreInitialAutoplayDelay(),
        },
      });

      this.bindImageLinks();
      this.handleMotionPreferenceChange();
    }

    bindImageLinks() {
      this.querySelectorAll('.aspadz-home-banner__media[data-image-link]').forEach((media) => {
        media.style.cursor = 'pointer';
        media.addEventListener('click', (e) => {
          window.location.href = media.dataset.imageLink;
        });
      });

      // Prevent button clicks from bubbling up to the media layer
      this.querySelectorAll('.aspadz-home-banner__button').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
    }

    restoreInitialAutoplayDelay() {
      if (this.hasRestoredInitialDelay || !this.swiper?.params?.autoplay) return;

      this.hasRestoredInitialDelay = true;
      this.swiper.params.autoplay.delay = this.normalAutoplayDelay;
      this.swiper.originalParams.autoplay.delay = this.normalAutoplayDelay;
      this.style.setProperty('--aspadz-home-banner-delay', `${this.normalAutoplayDelay}ms`);
    }

    handleMotionPreferenceChange() {
      this.classList.toggle('aspadz-home-banner--reduced-motion', this.reducedMotion.matches);

      if (!this.swiper?.autoplay) return;

      if (this.reducedMotion.matches) {
        this.swiper.autoplay.stop();
      } else {
        this.swiper.autoplay.start();
      }
    }
  }

  if (!window.customElements.get('aspadz-home-banner')) {
    window.customElements.define('aspadz-home-banner', AspadzHomeBanner);
  }
})();
